<p-fieldset legend="Informações do Ajuste">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" id="identificacao-tab" data-toggle="tab" href="#identificacao" role="tab"
        aria-controls="identificacao" aria-selected="true">Identificação</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="itens-tab" data-toggle="tab" href="#itens" role="tab" aria-controls="itens"
        aria-selected="true">Itens do Ajuste</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="financeiro-tab" data-toggle="tab" href="#financeiro" role="tab" aria-controls="financeiro"
        aria-selected="true">Financeiro</a>
    </li>
    <li class="nav-item" *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
      <a class="nav-link" id="exigencia-tab" data-toggle="tab" href="#exigencia" role="tab" aria-controls="exigencia"
        aria-selected="true">Exigência e Cláusulas</a>
    </li>
    <li class="nav-item" *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
      <a class="nav-link" id="vigencia-tab" data-toggle="tab" href="#vigencia" role="tab" aria-controls="vigencia"
        aria-selected="true">Gestor e Vigência</a>
    </li>
    <li class="nav-item" *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
      <a class="nav-link" id="publicacao-tab" data-toggle="tab" href="#publicacao" role="tab" aria-controls="publicacao"
        aria-selected="true">Publicações</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="conclusao-tab" data-toggle="tab" href="#conclusao" role="tab" aria-controls="conclusao"
        aria-selected="true">Conclusão</a>
    </li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane fade" id="itens" role="tabpanel" aria-labelledby="itens-tab">
      <p-fieldset legend="Lotes">
        <table class="table table-eddy table-sm">
          <thead>
            <tr>
              <th style="width: 15%" scope="col"></th>
              <th style="width: 55%" scope="col">Descrição</th>
              <th style="width: 10%" scope="col">Quantidade</th>
              <th style="width: 10%" scope="col">Unidade</th>
              <th style="width: 10%" scope="col">Orçamento</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of arquivo.lotes">
              <td>
                <div class="checkbox checbox-switch switch-primary">
                  <label>
                    <input [(ngModel)]="item.marcado" [ngModelOptions]="{standalone: true}" type="checkbox" />
                    <span></span>
                  </label>
                </div>
              </td>
              <td style="width: 55%">{{item.NumeroLote}} - {{item.DescricaoLote}}</td>
              <td style="width: 10%">{{item.Quantidade}}</td>
              <td style="width: 10%">{{item.UnidadeMedida}}</td>
              <td style="width: 10%">{{item.OrcamentoLoteNao}}</td>
            </tr>
          </tbody>
        </table>
      </p-fieldset>
    </div>
    <div class="tab-pane fade show active" id="identificacao" role="tabpanel" aria-labelledby="identificacao-tab">
      <p-fieldset legend="Identificação do Ajuste" *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
        <div class="row">
          <div class="col-3">
            <label for="contratoId" class="required">Nº Contrato / Ano</label>
            <select *ngIf="!entidade.id" id="contratoId" class="form-control" [(ngModel)]="arquivo.contratoId"
              [ngModelOptions]="{standalone: true}" (change)="atribuirContrato()">
              <option *ngFor="let item of listaContrato" [ngValue]="item.id">
                {{item.numero}}/{{item.ano}}
              </option>
            </select>
            <span *ngIf="entidade.id" class="form-control">{{arquivo.NumContrato}}/{{arquivo.AnoContrato}}</span>
          </div>
          <div class="col-3">
            <label for="ValorContrato" class="required">Valor do Contrato</label>
            <input id="ValorContrato" type="text" class="form-control" [(ngModel)]="arquivo.ValorContrato"
              [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskConfig">
          </div>
          <div class="col-3">
            <label for="Quantidade" class="required">Quantidade</label>
            <input id="Quantidade" type="text" class="form-control" [(ngModel)]="arquivo.Quantidade"
              [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
          </div>
          <div class="col-3">
            <label for="UnidadeMedida" class="required">Unidade de Medida</label>
            <input id="UnidadeMedida" type="text" class="form-control" [(ngModel)]="arquivo.UnidadeMedida"
              [ngModelOptions]="{standalone: true}">
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="ObjetoContrato" class="required">Objeto do Contrato</label>
            <textarea class="form-control" id="ObjetoContrato" rows="5" [(ngModel)]="arquivo.ObjetoContrato"
              [ngModelOptions]="{standalone: true}"></textarea>
          </div>
        </div>
      </p-fieldset>
      <p-fieldset legend="Identificação do contratado">
        <div class="row">
          <div class="col-3">
            <label for="tipoDoc" class="required">Tipo de Documento</label>
            <select id="tipoDoc" class="form-control" [(ngModel)]="arquivo.tipoDoc"
              [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of opcoesDoc" [ngValue]="item">{{item}}</option>
            </select>
          </div>
          <div class="col-3">
            <label for="documento" class="required">Documento</label>
            <input id="documento" *ngIf="arquivo?.tipoDoc === 'CPF'" type="text" class="form-control"
              [(ngModel)]="arquivo.CPF" [ngModelOptions]="{standalone: true}" [imask]="{mask: '000.000.000-00'}"
              unmask="true">
            <input id="documento" *ngIf="arquivo?.tipoDoc === 'CNPJ'" type="text" class="form-control"
              [(ngModel)]="arquivo.CNPJ" [ngModelOptions]="{standalone: true}" [imask]="{mask: '00.000.000/0000-00'}"
              unmask="true">
            <input id="documento" *ngIf="arquivo?.tipoDoc === 'OUTRO'" type="text" class="form-control"
              [(ngModel)]="arquivo.OutroDoc" [ngModelOptions]="{standalone: true}">
          </div>
          <div class="col-6">
            <label for="NomeRazaoSocial" class="required">Razão Social</label>
            <input id="NomeRazaoSocial" type="text" class="form-control" [(ngModel)]="arquivo.NomeRazaoSocial"
              [ngModelOptions]="{standalone: true}">
          </div>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="financeiro" role="tabpanel" aria-labelledby="financeiro-tab">
      <p-fieldset legend="Financeiro" *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
        <div class="row">
          <div class="col-12">
            <label for="ClausulasFinanceira" class="required">Cláusulas Financeiras</label>
            <textarea class="form-control" id="ClausulasFinanceira" rows="3" [(ngModel)]="arquivo.ClausulasFinanceira"
              [ngModelOptions]="{standalone: true}"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <label for="ClassificacaoEconomica" class="required">Tipo Classificação Econômica</label>
            <select id="ClassificacaoEconomica" class="form-control"
              [(ngModel)]="arquivo.ClassificacaoEconomica.TipoClassificacaoEconomica"
              [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of opcoesReceitaDespesa" [ngValue]="item.id">{{item.nome}}</option>
            </select>
          </div>
          <div class="col-md-9">
            <label for="classificacaoCod" class="required">Código Classificação Econômica</label>
            <select id="classificacaoCod" *ngIf="arquivo.ClassificacaoEconomica.TipoClassificacaoEconomica === 1"
              class="form-control" [(ngModel)]="arquivo.ClassificacaoEconomica.CodigoClassificacaoEconomica"
              [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of listaReceita" [ngValue]="item.id">{{item.id}} - {{item.nome}}</option>
            </select>
            <select id="classificacaoCod" *ngIf="arquivo.ClassificacaoEconomica.TipoClassificacaoEconomica === 2"
              class="form-control" [(ngModel)]="arquivo.ClassificacaoEconomica.CodigoClassificacaoEconomica"
              [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of listaDespesa" [ngValue]="item.id">{{item.id}} - {{item.nome}}</option>
            </select>
          </div>
        </div>
      </p-fieldset>
      <p-fieldset legend="Nota de Empenho/Documento Similar" *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
        <lib-licitacao-audesp-empenho [entidade]="arquivo" [campo]="'NotaEmpenho'" [ajuste]="entidade"
          [contrato]="contrato?.id"></lib-licitacao-audesp-empenho>
      </p-fieldset>
      <p-fieldset legend="Nota de Empenho/Documento Similar" *ngIf="tipoAjuste === 'AJUSTE_EMPENHO'">
        <div class="row" *ngIf="arquivo.NotaEmpenho?.length > 0">
          <div class="col-2">
            <label class="font-weight-bold text-primary">Buscar Empenhos</label>
            <input [(ngModel)]="filtroEmpenho" (keyup)="buscarEmpenhos()" type="text" class="form-control"
              placeholder="Nº Empenho" aria-label="Nº Empenho" aria-describedby="button-addon2">
          </div>
          <div class="col-2">
            <label class="required">Nota Empenho</label>
            <span class="form-control">{{arquivo.NotaEmpenho[0].NumNotaEmpenho}}</span>
          </div>
          <div class="col-2">
            <label class="required">Data</label>
            <span class="form-control">{{arquivo.NotaEmpenho[0].NotaEmpenhoDt}}</span>
          </div>
          <div class="col-2">
            <label class="required">Valor</label>
            <span class="form-control text-right">
              {{arquivo.NotaEmpenho[0].NotaEmpenhoValor | number:'1.2-2'}}
            </span>
          </div>
          <div class="col-4">
            <label for="FonteRecursos" class="required">Fonte de Recursos</label>
            <select id="FonteRecursos" class="form-control" [(ngModel)]="arquivo.NotaEmpenho[0].FonteRecursos"
              [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of opcoesRecurso" [ngValue]="item.id">{{item.nome}}</option>
            </select>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-12 table-responsive">
            <table class="table table-sm table-eddy">
              <thead>
                <tr>
                  <td></td>
                  <th scope="col" class="text-center">Número</th>
                  <th scope="col" class="text-center">Data</th>
                  <th scope="col">Recurso</th>
                  <th scope="col" class="text-right">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of listaEmpenho" [class]="item.classeCSS">
                  <td>
                    <div class="checkbox checbox-switch switch-primary">
                      <label>
                        <input type="checkbox" [checked]="arquivo.NotaEmpenho[0].empenhoId === item.id"
                          (click)="atribuirEmpenho(item)" />
                        <span></span>
                      </label>
                    </div>
                  </td>
                  <th scope="row" class="text-center">{{("00000" + item.numero).slice(-5) }}/{{item.exercicio.ano}}</th>
                  <td class="text-center">{{item.data_empenho | date:'dd/MM/yyyy':'GMT'}}</td>
                  <td>{{item.ficha.recurso.codigo}} - {{item.ficha.recurso.nome}}</td>
                  <td class="text-right">{{item.valor_empenho | number:'1.2-2'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="exigencia" role="tabpanel" aria-labelledby="exigencia-tab"
      *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
      <p-fieldset legend="Exigências e Cláusulas">
        <div class="row mt-3">
          <div class="col-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Exigência de garantia?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.ExigenciaGarantiaNao" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <div class="col-3" *ngIf="arquivo.ExigenciaGarantiaNao === 'S'">
            <label for="ValorGarantia" class="required">Valor da garantia</label>
            <input id="ValorGarantia" type="text" class="form-control"
              [(ngModel)]="arquivo.ExigenciaGarantiaSim.ValorGarantia" [ngModelOptions]="{standalone: true}"
              unmask="typed" [imask]="imaskConfig">
          </div>
          <div class="col-3" *ngIf="arquivo.ExigenciaGarantiaNao === 'S'">
            <label for="ValorGarantiaPercentualContrato" class="required">Valor da garantia %</label>
            <input id="ValorGarantiaPercentualContrato" type="text" class="form-control"
              [(ngModel)]="arquivo.ExigenciaGarantiaSim.ValorGarantiaPercentualContrato"
              [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskConfig">
          </div>
        </div>
        <div class="row" *ngIf="arquivo.ExigenciaGarantiaNao === 'S'">
          <div class="col-12">
            <label for="ClausulasFinanceira" class="required">Cláusulas de garantia</label>
            <textarea class="form-control" id="ClausulasFinanceira" rows="3"
              [(ngModel)]="arquivo.ExigenciaGarantiaSim.ClausulasGarantia"
              [ngModelOptions]="{standalone: true}"></textarea>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Exigência de Cláusulas Penais?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.ClausulasPenaisNao" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="arquivo.ClausulasPenaisNao === 'S'">
          <div class="col-12">
            <label for="ClausulasPenaisSim" class="required">Cláusulas Penais</label>
            <textarea class="form-control" id="ClausulasPenaisSim" rows="3" [(ngModel)]="arquivo.ClausulasPenaisSim"
              [ngModelOptions]="{standalone: true}"></textarea>
          </div>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="vigencia" role="tabpanel" aria-labelledby="vigencia-tab"
      *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
      <p-fieldset legend="Gestor e Vigência do contrato">
        <div class="row mt-3">
          <div class="col-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Há servidor designado para a gestão do contrato?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.GestorDoContratoNao" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <div class="col-3" *ngIf="arquivo.GestorDoContratoNao === 'S'">
            <label for="GestorCPF" class="required">CPF do gestor do contrato</label>
            <input id="GestorCPF" type="text" class="form-control" [(ngModel)]="arquivo.GestorDoContratoSim.GestorCPF"
              [ngModelOptions]="{standalone: true}" [imask]="{mask: '000.000.000-00'}" unmask="true">
          </div>
          <div class="col-3" *ngIf="arquivo.GestorDoContratoNao === 'S'">
            <label for="GestorCargo" class="required">Cargo do gestor do contrato</label>
            <input id="GestorCargo" type="text" class="form-control"
              [(ngModel)]="arquivo.GestorDoContratoSim.GestorCargo" [ngModelOptions]="{standalone: true}">
          </div>
        </div>
        <hr />
        <div class="row mt-3">
          <div class="col-6">
            <div class="row col-form-label">
              <label class="required col-12">
                Exigência de Cláusulas Penais?
              </label>
              <p-selectButton [options]="opcoesVigencia" optionValue="id" [(ngModel)]="arquivo.vigencia" class="col-12"
                [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <div class="col-2" *ngIf="arquivo.vigencia === 'DATA'">
            <label for="InicioVigenciaDt" class="required">Data início</label>
            <p-calendar (onFocus)="onFocusDate()" id="InicioVigenciaDt"
              [(ngModel)]="arquivo.VigenciaPorData.InicioVigenciaDt" [ngModelOptions]="{standalone: true}"
              inputStyleClass="form-control" dataType="string" dateFormat="dd/mm/yy" [showOnFocus]="true"
              [showButtonBar]="true" [showIcon]="true">
            </p-calendar>
          </div>
          <div class="col-2" *ngIf="arquivo.vigencia === 'DATA'">
            <label for="FimVigenciaDt" class="required">Data término</label>
            <p-calendar (onFocus)="onFocusDate()" id="FimVigenciaDt" [(ngModel)]="arquivo.VigenciaPorData.FimVigenciaDt"
              [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="string"
              dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
            </p-calendar>
          </div>
          <div class="col-2" *ngIf="arquivo.vigencia === 'ORDEM_SERVICO'">
            <label for="ValidadeMeses" class="required">Validade do contrato</label>
            <input id="ValidadeMeses" type="text" class="form-control" [(ngModel)]="arquivo.ValidadeMeses"
              [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
          </div>
          <div class="col-2">
            <label for="AssinaturaDt" class="required">Data da assinatura</label>
            <p-calendar (onFocus)="onFocusDate()" id="AssinaturaDt" [(ngModel)]="arquivo.AssinaturaDt"
              [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="string"
              dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
            </p-calendar>
          </div>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="publicacao" role="tabpanel" aria-labelledby="publicacao-tab"
      *ngIf="tipoAjuste === 'AJUSTE_CONTRATO'">
      <p-fieldset legend="Data da publicação do Ajuste">
        <div class="row">
          <label class="required col-12 col-form-label">
            Houve publicação do Ajuste em veículos de comunicação?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
            [(ngModel)]="arquivo.PublicacaoExtratoContratoNao" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </div>
        <lib-licitacao-audesp-publicacao [entidade]="arquivo" [campo]="'PublicacaoExtratoContrato'"
          *ngIf="arquivo.PublicacaoExtratoContratoNao === 'S'"></lib-licitacao-audesp-publicacao>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="conclusao" role="tabpanel" aria-labelledby="conclusao-tab">
      <lib-licitacao-audesp-termo-ciencia [entidade]="arquivo" [campo]="'TermoCienciaContratantes'"
        [titulo]="'Responsável pelo Ajuste - parte Contratante'">
      </lib-licitacao-audesp-termo-ciencia>
      <lib-licitacao-audesp-termo-ciencia [entidade]="arquivo" [campo]="'TermoCienciaContratados'"
        [titulo]="'Responsável pelo Ajuste - parte Contratado'">
      </lib-licitacao-audesp-termo-ciencia>
    </div>
  </div>
</p-fieldset>